import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

export interface TableState {
  params: Record<string, unknown>;
  filterParams?: Params;
}

@Injectable({
  providedIn: 'root'
})

export class TableStateService {
  constructor() { }
  private stateMap = new Map<string, TableState>();
  private readonly prefix = 'table-state-';

  setState(key: string, state: unknown): void {
    sessionStorage.setItem(this.prefix + key, JSON.stringify(state));
  }

  getState<T>(key: string): T | null {
    const value = sessionStorage.getItem(this.prefix + key);
    return value ? JSON.parse(value) : null;
  }

  clearState(key: string): void {
    sessionStorage.removeItem(this.prefix + key);
  }

  clearAllStates(): void {
    Object.keys(sessionStorage)
      .filter(key => key.startsWith(this.prefix))
      .forEach(key => sessionStorage.removeItem(key));
  }
}
